import React, { useState } from 'react';
import UIInput from '@/components/shared/UIInput';
import { ReactComponent as SearchIcon } from '@/img/search.svg';
import { ReactComponent as ClearIcon } from '@/img/x.svg';
import './UIInputSearch.scss';

export interface UIInputSearchProps {
  /**
   * Placeholder для пошуку
   */
  placeholder?: string;

  /**
   * Поточне значення пошуку
   */
  value?: string;

  /**
   * Обробник зміни значення
   */
  onChange?: (value: string) => void;

  /**
   * Обробник очищення
   */
  onClear?: () => void;

  /**
   * Розмір компонента
   */
  size?: 'small' | 'medium' | 'large';

  /**
   * Заблокований стан
   */
  disabled?: boolean;

  /**
   * Повний width
   */
  fullWidth?: boolean;

  /**
   * Додатковий CSS клас
   */
  className?: string;

  /**
   * Лейбл
   */
  label?: string;

  /**
   * Текст помилки
   */
  error?: string;
}

const baseClass = 'UIInputSearch';

const UIInputSearch: React.FC<UIInputSearchProps> = ({
                                                       placeholder = 'Search',
                                                       value,
                                                       onChange = (val) => console.log('Search changed:', val),
                                                       onClear = () => console.log('Search cleared'),
                                                       size = 'medium',
                                                       disabled = false,
                                                       fullWidth = false,
                                                       className = '',
                                                       label,
                                                       error,
                                                     }) => {
  const [searchTerm, setSearchTerm] = useState(value || '');

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchTerm(newValue);
    onChange(newValue);
  };

  const handleClear = () => {
    setSearchTerm('');
    onClear();
    onChange('');
  };

  const containerClasses = [baseClass, className].filter(Boolean).join(' ');

  return (
    <div className={containerClasses}>
      <div className={`${baseClass}__search-wrapper`}>
        <UIInput
          placeholder={placeholder}
          size={size}
          fullWidth={fullWidth}
          value={searchTerm}
          onChange={handleSearchChange}
          disabled={disabled}
          label={label}
          error={error}
        />

        {/* Іконка: лупа або хрестик */}
        {searchTerm ? (
          <ClearIcon
            className={`${baseClass}__icon ${baseClass}__icon--clear`}
            onClick={handleClear}
          />
        ) : (
          <SearchIcon className={`${baseClass}__icon ${baseClass}__icon--search`} />
        )}
      </div>
    </div>
  );
};

export default UIInputSearch;